import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { Form, Field, Formik } from "formik";
import moment from "moment";
import { DateRangeField } from "pages/_components/fields/DateRangeField";
import Selector from "pages/_components/fields/formik/Selector";
import Button from "pages/_components/Button";
import { connect } from "react-redux";
import {
  actions as afipPaymentLinkActions,
  selectors as afipPaymentLinkSelectors,
} from "reducers/afipPaymentLink";
import * as i18n from "util/i18n";

const FORM_ID = "payments.filter";

const TransactionFilters = ({
  handleClickHideFilters,
  categories,
  entities,
  isDesktop
}) => {
  const dispatch = useDispatch();
  const filters = useSelector(afipPaymentLinkSelectors.getPaymentsFilters);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);


  const initialValues = {
    dateFrom: filters?.dateFrom || null,
    dateTo: filters?.dateTo || null,
    dateRange: [filters?.dateRange[0] || null, filters?.dateRange[1] || null],
    entity: filters?.entity || "",
    category: filters?.category || "",
  };
  
    useEffect(() => {
        if (selectedCategoryId) {
            dispatch(afipPaymentLinkActions.newServicePaymentPre({ categoryId: selectedCategoryId }));
        }
    }, [selectedCategoryId]);

    useEffect(() => {
      if (categories.length == 0)
        dispatch(afipPaymentLinkActions.newServicePaymentPre());
    }, []);

  const handleSubmit = (values) => {
    const [from, to] = values.dateRange || [];

    const dateFrom = from ? from.toISOString().slice(0, 10) + "T00:00:00" : null;
    const dateTo = to ? to.toISOString().slice(0, 10) + "T23:59:59" : null;
    const entity = values.entity !=null && values.entity != "" ? values.entity : null;
    const category = values.category !=null && values.category != "" ? values.category : null;

    dispatch(
      afipPaymentLinkActions.listPaymentsHistory( { dateFrom, dateTo, category, entity  })
    );
    dispatch(
      afipPaymentLinkActions.setPaymentsFilters({
        filter: "period",
        ...values,
      })
    );

    handleClickHideFilters();
  };

  const handleClear = (setFieldValue) => {
    setFieldValue("dateRange", [null, null]);
    setFieldValue("category", "");
    setFieldValue("entity", "");
  };

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit}>
      {({ setFieldValue }) => (
        <Form className="transaction-filter">
          

              {isDesktop ? ( <>
              <Row className="filters">
              <Col className="col-6" sm={6} md={6}>
              <Field
                name="category"
                clearable={false}
                searchable={false}
                onChange={(value) => setSelectedCategoryId(value)}
                label={i18n.get("payments.filter.category")}
                placeholder={i18n.get("global.select.option.placeholder")}
                component={Selector}
                options={categories
                    ? categories.map(({ id, description }) => ({
                        value: id,
                        label: description,
                    }))
                    : []}
              />
                <Field
                name="entity"
                clearable={false}
                searchable={false}
                label={i18n.get("payments.filter.business")}
                placeholder={i18n.get("global.select.option.placeholder")}
                component={Selector}
                  options={entities
                    ? entities.map(({ id, description }) => ({
                        value: id,
                        label: description,
                    }))
                    : []}
              />
             
            </Col>
         
            <Col className="col-6" sm={6} md={6}>
              <Field
                component={DateRangeField}
                hidePlaceholder
                idForm={FORM_ID}
                minDate={moment().add(-1, "years")}
                maxDate={moment()}
                name="dateRange"
                dateFormat="dd/MM/yyyy"
                selectsRange
                showMonthYearDropdown
                scrollableMonthYearDropdown
                noEdit
              />

              
            </Col></Row></>
              ) : (    
            <>
              <Row className="filters"><Col className="col-12" sm={12} md={12}>
              <Field
                name="category"
                clearable={false}
                searchable={false}
                onChange={(value) => setSelectedCategoryId(value)}
                label={i18n.get("payments.filter.business")}
                placeholder={i18n.get("global.select.option.placeholder")}
                component={Selector}
                options={categories
                    ? categories.map(({ id, description }) => ({
                        value: id,
                        label: description,
                    }))
                    : []}
              />
               </Col></Row>
                

                 <Row className="filters"><Col className="col-12" sm={12} md={12}>
                <Field
                name="entity"
                clearable={false}
                searchable={false}
                label={i18n.get("payments.filter.category")}
                placeholder={i18n.get("global.select.option.placeholder")}
                component={Selector}
                  options={entities
                    ? entities.map(({ id, description }) => ({
                        value: id,
                        label: description,
                    }))
                    : []}
              />
               </Col></Row>
              <Row className="filters"><Col className="col-12" sm={12} md={12}>
                <Field
                component={DateRangeField}
                hidePlaceholder
                idForm={FORM_ID}
                minDate={moment().add(-10, "years")}
                maxDate={moment()}
                name="dateRange"
                dateFormat="dd/MM/yyyy"
                selectsRange
                showMonthYearDropdown
                scrollableMonthYearDropdown
                noEdit
              />
                           
            </Col></Row>
            </>
              )}
          <Row className="filter-footer">
            <Col sm={12} md={6} className="col-12 col-no-pad-mobile" style={{ alignSelf: "flex-end" }}>
              <Button bsStyle="outline" label="transactions.clean.filters" onClick={() => handleClear(setFieldValue)} />
            </Col>
            <Col sm={12} md={6} className="col-12 col-no-pad-mobile" style={{ alignSelf: "flex-end" }}>
              <Button bsStyle="primary" label="product.filters.filter" type="submit" block />
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
};

const mapStateToProps = (state) => ({
    categories: afipPaymentLinkSelectors.getCategories(state),
    entities: afipPaymentLinkSelectors.getEntities(state),
});

export default connect(mapStateToProps)(TransactionFilters);

